import {
    createSlice
} from '@reduxjs/toolkit';

// 用户信息接口类型
const userInitialState = {
    userInfo: null,
};

// 用户状态管理slice
const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        // 设置用户信息
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },

        // 清除用户信息
        clearUserInfo: (state) => {
            state.userInfo = null;
        },

    },
});

// 导出actions
export const {
    setUserInfo,
    clearUserInfo,
} = userSlice.actions;

// 导出reducer
export default userSlice.reducer;